import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  creativeCard: {
    margin: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    position: 'relative',
    boxShadow: '10px 10px 20px rgba(0,0,0,0.2)',
    background: '#fff',
  },

  gameName: {
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '1.2rem',
    paddingTop: 5,
    marginTop: 5,
    marginBottom: 5,
    color: '#fff',
    cursor: 'pointer',
    fontWeight: 200,
  },
  gameNameNoLink: {
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '1.2rem',
    marginTop: 5,
    marginBottom: 5,
    color: '#222',
    cursor: 'pointer',
  },
  authorName: {
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '0.8rem',
    marginTop: 5,
    marginBottom: 5,
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  divider: {
    width: '60%',
    borderTop: '1px solid #ddd',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: 6,
  },
  summary: {
    paddingBottom: 6,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 10,
  },
}));
